import { render, staticRenderFns } from "./TableHeadDataSales.vue?vue&type=template&id=571f13c7"
import script from "./TableHeadDataSales.vue?vue&type=script&lang=ts"
export * from "./TableHeadDataSales.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports